import state from './state';

import { IGetters } from "@/interfaces/state.interface";
import { PortalType } from "@/enums/portal-types";

const getters: IGetters = {
	router: () => state.router,
	isLoggedIn: () => state.isLoggedIn,
	questions: () => {
		if (!state.questions) return [];

		return state.questions;
	},
	question: (id: number) => {
		if (!state.questions || !state.questions[id]) return;

		return state.questions[id];
	},
	portal: () => {
		return state.portal;
	},
	preferredPortalUrl: () => {
		switch (state.preferredPortalType) {
			case (PortalType.MASTERS):
				return 'mastersportal.com';
			case (PortalType.BACHELORS):
				return 'bachelorsportal.com';
			case (PortalType.PHD):
				return 'phdportal.com';
			case (PortalType.SHORT_COURSES):
				return 'shortcoursesportal.com';
			case (PortalType.DISTANCE_LEARNING):
				return 'distancelearningportal.com';
			case (PortalType.PREPARATION_COURSES):
				return 'preparationcoursesportal.com';
			default:
				return 'mastersportal.com';
		}
	},
	portalSearchPath: (): string => {
		switch (state.preferredPortalType) {
			case (PortalType.MASTERS):
				return 'master';
			case (PortalType.BACHELORS):
				return 'bachelor';
			case (PortalType.PHD):
				return 'phd';
			case (PortalType.SHORT_COURSES):
				return 'course';
			case (PortalType.DISTANCE_LEARNING):
				return 'distance-learning';
			default:
				return 'mastersportal.com';
		}
	},
	userName: () => {
		if (!state.userName) return '';

		return state.userName;
	},
	topThreeLetters: () => {
		if (!state.results || !state.results.threeLetterCode) return '';

		return state.results.threeLetterCode;
	},
	personalityTypes: () => {
		if (!state.results || !state.results.personalityTypes || !state.results.personalityTypes.length) return [];

		return state.results.personalityTypes;
	},
	disciplines: () => {
		if (!state.results || !state.results.disciplines) return [];

		return state.results.disciplines;
	},
	firstUnansweredQuestion: () => {
		let questionId = 0;

		if (!state.questions) return questionId;

		for (let i = 0; i < state.questions.length; i++) {

			if (state.questions[i].answer === 0 || i === state.questions.length - 1) {
				questionId = i;
				break;
			}
		}

		return questionId;
	}
};

export default getters;